import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import {
	getIntegrationStateColor,
	getIntegrationStateTranslationKey,
} from "@msuite/utils/integrations";
import type { AutoIntegrationListItem, PersonioPerson, WebfleetObject } from "@msuite/utils/types";

/** Props Interface */
interface IntegrationStateProps {
	state: AutoIntegrationListItem<WebfleetObject | PersonioPerson>["state"];
}

export function IntegrationState({ state }: IntegrationStateProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			variant="plain"
			color={getIntegrationStateColor(state)}
		>
			{t(getIntegrationStateTranslationKey(state))}
		</Tag>
	);
}
